import { createFileRoute } from "@tanstack/react-router"
import { OrganizationsLayout } from "@/components"

export const Route = createFileRoute("/_authenticated/_organizations")({
  component: OrganizationsLayout,
})
